import { Component } from '@theme/component';

/**
 * @typedef {object} Refs
 * @property {HTMLElement[]} [item]
 *
 * @extends {Component<Refs>}
 */
class PrettyPortalMenuBar extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('click', this.#handleOutsideClick);
    document.addEventListener('keydown', this.#handleKeydown);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('click', this.#handleOutsideClick);
    document.removeEventListener('keydown', this.#handleKeydown);
  }

  /**
   * Toggle a dropdown item open/closed. Bound via `on:click`.
   * @param {PointerEvent} event
   */
  toggleItem(event) {
    const target = event.target instanceof HTMLElement ? event.target : null;
    const trigger = target?.closest('[data-pp-menu-bar-trigger]');
    const item = trigger?.closest('[data-pp-menu-bar-item]');
    if (!(item instanceof HTMLElement)) return;

    const isOpen = item.hasAttribute('data-open');
    this.#closeAll();

    if (!isOpen) {
      item.setAttribute('data-open', '');
      trigger?.setAttribute('aria-expanded', 'true');
      if (item.classList.contains('pp-menu-bar__item--main')) {
        document.documentElement.setAttribute('scroll-lock', '');
      }
    }
  }

  #closeAll() {
    for (const item of this.refs.item ?? []) {
      item.removeAttribute('data-open');
      item.querySelector('[data-pp-menu-bar-trigger]')?.setAttribute('aria-expanded', 'false');
    }
    document.documentElement.removeAttribute('scroll-lock');
  }

  /**
   * @param {MouseEvent} event
   */
  #handleOutsideClick = (event) => {
    if (event.target instanceof Node && this.contains(event.target)) return;
    this.#closeAll();
  };

  /**
   * @param {KeyboardEvent} event
   */
  #handleKeydown = (event) => {
    if (event.key === 'Escape') this.#closeAll();
  };
}

if (!customElements.get('pretty-portal-menu-bar')) {
  customElements.define('pretty-portal-menu-bar', PrettyPortalMenuBar);
}
